export const PROFILE = 'profile';
export const PASSWORD = 'password';
export const PAYMENTS = 'payments';
export const PRICING = 'pricing';



// WEBPACK FOOTER //
// ./src/constants/usersSettings.js